import { setContext } from 'apollo-link-context'
import { getCsrfHeaders } from './auth-utils'

export const apolloLinkCsrfHeader = setContext(async () => ({
  headers: getCsrfHeaders(),
}))
